import DoglinkElement from "./DoglinkElement";
import icons from "../helpers/icons";
import React from "react";
import VismerKnappen from "./VismerKnappen";
import {withRouter, useHistory } from "react-router-dom";
import qs from "query-string";


const MineHunder = ({hunder}) => {
    let history = useHistory();
    const parsed = qs.parse(decodeURI(history.location.search));

    let antallVises = 5;
    if (parsed.mine !== undefined) {
        antallVises = parsed.mine;
    }
    const setAntallVises = (antall) => {
        let params = parsed;
        params.mine = antall;
        history.push(history.location.pathname + "?" + qs.stringify(params));
    };

    const rows = hunder
        .map(f =>
            <DoglinkElement
                key={f.hundId}
                linkTo={`/hund?id=${f.hundId}`}
                iconFirst={icons.han}
                iconLast={icons.arb}
                data={f}
                greyOverlay={true}
            />
    ).splice(0, antallVises);


    return (
        <>
            { hunder && hunder.length > 0 &&
                <li>
                    <strong>MINE HUNDE</strong>
                    <ul>
                        {rows}

                        <VismerKnappen
                            total={hunder.length}
                            maxStep="10"
                            renderedAmount={antallVises}
                            incrementer={setAntallVises}
                        />
                    </ul>
                </li>
            }

        </>
    );

};
export default withRouter (MineHunder);